module.exports = __webpack_public_path__ + "img/triangle-wave.7907781a.svg";